import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { logger } from "../lib/logger";
import { TOAST_LOGIN_SUCCESS, TOAST_LOGIN_ERROR, LOGIN_HEADER, LOGIN_FORM_TITLE, LOGIN_FORM_HEADING, LOGIN_FORM_DESC, LOGIN_EMAIL_PLACEHOLDER, LOGIN_PASSWORD_PLACEHOLDER, LOGIN_SUBMIT, LOGIN_SUBMITTING } from "../lib/constants";

function log(...args) { logger.info("[Login]", ...args); }
function logErr(...args) { logger.error("[Login]", ...args); }

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    log("=== FORM SUBMIT === email:", email);
    setLoading(true);
    try {
      log("Calling login()...");
      await login(email.trim(), password);
      log("Login succeeded, navigating to /backoffice");
      toast.success(TOAST_LOGIN_SUCCESS);
      navigate("/backoffice");
    } catch (err) {
      logErr("Login failed:", err.message);
      toast.error(err.message || TOAST_LOGIN_ERROR);
    } finally {
      setLoading(false);
      log("Loading state reset");
    }
  }

  return (
    <div data-id="page-admin-login" className="min-h-screen bg-offwhite flex flex-col">
      <header className="px-6 md:px-12 py-6 border-b border-fendi/60 flex items-center justify-between">
        <Link to="/" className="font-serif text-2xl text-softblack" data-id="admin-login-logo" data-testid="admin-login-logo">
          Hub<span className="text-champagne">.</span>
        </Link>
        <span className="eyebrow">{LOGIN_HEADER}</span>
      </header>
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <form onSubmit={onSubmit} data-id="admin-login-form" data-testid="admin-login-form" className="w-full max-w-md bg-white border border-fendi p-10">
          <p className="eyebrow">{LOGIN_FORM_TITLE}</p>
          <h1 className="font-serif text-4xl text-softblack mt-3">{LOGIN_FORM_HEADING}</h1>
          <p className="text-warmgray text-sm mt-3 font-light">
            {LOGIN_FORM_DESC}
          </p>
          <div className="mt-10 space-y-6">
            <label className="block">
              <span className="eyebrow">E-mail</span>
              <input
                required type="email" data-id="admin-login-email" data-testid="admin-login-email"
                className="editorial-field mt-3"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={LOGIN_EMAIL_PLACEHOLDER}
              />
            </label>
            <label className="block">
              <span className="eyebrow">Palavra-passe</span>
              <input
                required type="password" data-id="admin-login-password" data-testid="admin-login-password"
                className="editorial-field mt-3"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={LOGIN_PASSWORD_PLACEHOLDER}
              />
            </label>
          </div>
          <button type="submit" disabled={loading} data-id="admin-login-submit" data-testid="admin-login-submit" className="btn-primary w-full mt-10 disabled:opacity-60">
            {loading ? LOGIN_SUBMITTING : LOGIN_SUBMIT}
          </button>
        </form>
      </main>
    </div>
  );
}
